export enum EventCategoryEnum {
  LISTA_DIG = 'listadig',
  LISTA_DIG_VARDEN = 'Lista Dig function',
  LISTA_SIG = 'listasig',
  LISTA_DIG_DIRECT = 'Lista Dig Direct (Scraper)',
  APP = 'appnedladdning',
  POPULAR_SEARCHES = 'PopularSearches',
  VARDEN_BOOKING = 'Vården Bokningsflöde',
  EMAIL_BOOKING = 'bokning',
  DOKTORSE_RECEPT = 'RECEPT BUTTON Doktor.se - June 2019',
  DOKTORSE_MODAL = 'RECEPT MODAL Doktor.se - July 2019',
  MY_PAGES = 'MyPages',
  CARE_PROVIDER_UNIT = 'Care Provider Unit',
  SEARCHNAV = 'Search & navigation',
  HSA_CTA = 'HSA CTA button',
  TEST_CTA = 'Test CTA button',
}

export enum EventActionEnum {
  LISTA_DIG = 'eform',
  LISTA_DIG_IFRAME = 'iframe',
  LISTA_DIG_VARDEN_DIRECT = 'direct open',
  LISTA_DIG_VARDEN_BOOKING = 'booking open',
  LISTA_DIG_VARDEN_BANKIDSUCCESS = 'bank id success',
  LISTA_DIG_DIRECT_OPEN = 'direct open',
  LISTA_DIG_DIRECT_LISTADIG = 'lista dig click',
  LISTA_DIG_DIRECT_LOGGED_IN_REGULAR = 'logged in (regular)',
  LISTA_DIG_DIRECT_LOGGED_IN_QUEUE = 'logged in (queue)',
  LISTA_DIG_DIRECT_CONFIRMED_REGULAR = 'register click (regular)',
  LISTA_DIG_DIRECT_CONFIRMED_QUEUE = 'register click (queue)',
  LISTA_DIG_DIRECT_SUCCESS_REGULAR = 'success (regular)',
  LISTA_DIG_DIRECT_SUCCESS_QUEUE = 'success (queue)',
  LISTA_DIGDIRECT_BANKID = 'bank id',
  LISTA_DIGDIRECT_REGISTER_NOT_POSSIBLE = 'register not possible',
  LISTA_DIGDIRECT_ERROR = 'error',
  APPSTORE = 'appstore',
  GOOGLEPLAY = 'googleplay',
  POPULAR_SEARCHES_HOME_CLICK = 'click on homepage',
  BANNER_IMPRESSION = 'banner impression',
  BUTTON_CLICK = 'btn click',
  EMAIL_BOOKING_SEND = 'skickad förfrågan vården.se',
  EMAIL_BOOKING_TRY = 'försök skicka förfrågan vården.se',
  CTA_FIND_OTHER_CAREPROVIDERS = 'CTA find other care providers click',
  VARDEN_BOOKING_CLICK_MAIN_BOOKING_BTN = 'Click Boka button',
  VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN = 'Click Care Service Boka button',
  VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN = 'Click Care Service timeslot button',
  VARDEN_BOOKING_SELECT_SERVICE = 'Select treatment',
  VARDEN_BOOKING_SELECT_TIMESLOT = 'Select timeslot',
  VARDEN_BOOKING_CLICK_READ_MORE = 'Click Read more',
  VARDEN_BOOKING_SELECT_PRACTITIONER = 'Select practitioner',
  VARDEN_BOOKING_CLICK_CPRU_NAME = 'Click Care Provider name link',
  VARDEN_BOOKING_SEND_BOOKING_TRY = 'booking_Try',
  VARDEN_BOOKING_SEND_BOOKING = 'Send booking',
  VARDEN_BOOKING_BACKEND_RESPONSE = 'BE response',
  VARDEN_BOOKING_SUCCESS = 'Booking successful',
  HITTA_VARD_BUTTON_CLICK = 'Hitta vård button click',
  FREE_SEARCH_FIELD_CLICK = 'Free text field click',
  CHOOSE_LOCATION_BUTTON_CLICK = 'Choose location button click',
  LOCATION_DROPDOWN_CLICK = 'Location dropdown click',
  SEARCH_BUTTON_CLICK = 'Search button click',
  POPULAR_CARE_SERVICE_CLICK = 'Popular care service click',
  CARE_SERVICE_CLICK = 'Care service click',
  CARE_SERVICE_TYPE_CLICK = 'Care service type click',
  SYMPTOM_CLICK = 'Symptom click',
  MENU_ITEM_CLICK = 'Mega Menu item click',
  HSA_CTA_PHONE = 'Phone',
  HSA_CTA_WEBSITE = 'Website',
}
